import KmsHttpService from '@/servises/kmsHttpService';
import { getV2Endpoint } from '@/utils/apiV2Endpoints';

export default {
    getTemplates: (params) => {
        const endpoint = getV2Endpoint({ 'group': 'templates', 'endpoint': 'list' }, null);
        return KmsHttpService.get(endpoint, { params: params });
    },
    getActiveTemplate: (id) => {
        const endpoint = getV2Endpoint({ 'group': 'templates', 'endpoint': 'manage' }, { id: id });
        return KmsHttpService.get(endpoint, null);
    },
    getTemplateQuestions: (id) => {
        const endpoint = getV2Endpoint({ 'group': 'templates', 'endpoint': 'questions' }, { id: id });
        return KmsHttpService.get(endpoint, null);
    }
};
